(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gallery-carousel"] && !Shopify.designMode) return;
  try {
    
  function initGalleryCarouselScrollbars() {
    document.querySelectorAll('[data-section-type="gallery-carousel"] .swiper').forEach(function (swiperEl) {
      if (swiperEl.dataset.scrollbarInit) return;
      swiperEl.dataset.scrollbarInit = 'true';

      var track = swiperEl.querySelector(':scope > .gallery-carousel__scrollbar-track');
      var thumb = track ? track.querySelector('.gallery-carousel__scrollbar-thumb') : null;
      var wrapper = swiperEl.querySelector(':scope > .swiper-wrapper');
      if (!track || !thumb || !wrapper) return;

      var section = swiperEl.closest('[data-section-type="gallery-carousel"]');
      if (section && section.dataset.loopCarousel === 'true') {
        // Endlos-Loop hat kein echtes "Ende" - Leiste ergibt hier keinen Sinn.
        track.style.display = 'none';
        return;
      }

      function getTranslateX(el) {
        var transform = window.getComputedStyle(el).transform;
        if (!transform || transform === 'none') return 0;
        var m3d = transform.match(/matrix3d\(([^)]+)\)/);
        if (m3d) {
          var p = m3d[1].split(',').map(Number);
          return p[12] || 0;
        }
        var m2d = transform.match(/matrix\(([^)]+)\)/);
        if (m2d) {
          var p2 = m2d[1].split(',').map(Number);
          return p2[4] || 0;
        }
        return 0;
      }

      function update() {
        var containerWidth = swiperEl.clientWidth;
        var scrollWidth = wrapper.scrollWidth;
        var maxTranslate = scrollWidth - containerWidth;

        if (maxTranslate <= 1) {
          track.style.display = 'none';
          return;
        }
        track.style.display = '';

        var translateX = -getTranslateX(wrapper);
        var progress = Math.min(Math.max(translateX / maxTranslate, 0), 1);

        var thumbWidth = Math.max(15, Math.min(100, (containerWidth / scrollWidth) * 100));
        thumb.style.width = thumbWidth + '%';
        thumb.style.left = (progress * (100 - thumbWidth)) + '%';
      }

      (function loop() {
        update();
        requestAnimationFrame(loop);
      })();

      window.addEventListener('resize', update);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGalleryCarouselScrollbars);
  } else {
    initGalleryCarouselScrollbars();
  }

  document.addEventListener('shopify:section:load', initGalleryCarouselScrollbars);

  } catch(e) { console.error(e); }
})();
})();
